<template>
    <button
        type="button"
        class="inside_block --sm"
        :title="title"
        @click.stop="copy"
    >
        <BIconCheck v-if="isCopied" class="icon"/>
        <BIconCopy v-else class="icon"/>
    </button>
</template>

<script setup>
// core
import {ref, onUnmounted} from "vue";
import {useStore} from "vuex";

const props = defineProps({
    value: {
        type: String,
        default: ''
    },
    title: {
        type: String,
        default: ''
    },
    // i18n key for the toast; empty means no toast
    toast: {
        type: String,
        default: ''
    }
});

const store = useStore();
const isCopied = ref(false);
let resetTimer = null;

// same approach as WebhookPage.vue: hidden textarea + execCommand
const writeToClipboard = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
};

const copy = () => {
    if (!props.value) return;

    writeToClipboard(props.value);

    if (props.toast) {
        store.commit("setToastContent", {
            status: "success",
            description: props.toast,
        });
    }

    isCopied.value = true;
    clearTimeout(resetTimer);
    resetTimer = setTimeout(() => (isCopied.value = false), 1500);
};

onUnmounted(() => clearTimeout(resetTimer));
</script>

<style scoped lang="scss">
// .inside_block from SettingsNumberDialog, compact variant
.inside_block {
    position: relative;
    min-width: 27px;
    width: 27px;
    height: 27px;
    max-width: none;
    flex: 0 0 auto;
    padding: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 7px;
    border: 1px solid var(--general-color);
    background-color: #ffffff;
    cursor: pointer;
    transition: 0.25s;

    .icon {
        width: 13px;
        height: 13px;
        font-size: 13px;
        line-height: 1;
        fill: var(--general-color);
        color: var(--general-color);
        transition: 0.25s;
    }

    &:hover {
        background-color: var(--general-color);

        .icon {
            fill: #ffffff;
            color: #ffffff;
        }
    }
}
</style>
